import React from 'react';
import { oneOf, string } from 'prop-types';
import Arrow from 'components/Icons/Arrow';

const ArrowComponent = ({ direction, className }) => (
  <div className={className}>
    <Arrow rotate={direction === 'prev' ? 180 : 0} />
  </div>
);

ArrowComponent.propTypes = {
  direction: oneOf(['next', 'prev']).isRequired,
  className: string.isRequired
};

export default ArrowComponent;
